
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/estimates?${queryString}`);
    return response.data;
  },
  async getStatics(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/estimates-statistics?${queryString}`);
    return response.data;
  },
   async getMailById(id) {
    const response = await https.get(`/estimate-mail/${id}`);
    return response.data;
  },
   async getPdfById(id) {
    const response = await https.get(`/estimate-pdf/${id}`);
    return response.data;
  },
  async getById(id) {
    const response = await https.get(`/estimates/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/estimates`, payload);
    return response.data;
  },


  async update(id, payload) {
    const response = await https.post(`/estimates/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/estimates/${id}`);
    return response.data;
  },
});
